import { SALES_TAX_PRODUCTS_COLUMN_HEADERS_FOR_CSV_TEMPLATE } from '../../products-tab/utils';

export const downloadSalesTaxTransactionsTemplate = async (template: {
  text: string;
  link: string;
}) => {
  // Convert Google Drive link to direct download URL
  const baseUrl = template.link;
  const exportUrl = baseUrl.replace(
    /\/view.*$|\/edit.*$/,
    '/export?format=xlsx'
  );

  try {
    const response = await fetch(exportUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();

    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);

    const fileName = template.text;
    link.setAttribute('href', url);
    link.setAttribute('download', `${fileName}.xlsx`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading template:', error);
    throw error; // Re-throw to handle error in the calling component
  }
};

export const downloadSalesTaxProductsCSVTemplate = () => {
  const csvContent =
    SALES_TAX_PRODUCTS_COLUMN_HEADERS_FOR_CSV_TEMPLATE.join(',') + '\n';
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  const url = window.URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', 'sales_tax_products_template.csv');

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
